import './spinner.scss';
export const Spinner = ({ height }: { height?: string }) => {
  return (
    <div className={`a-spinner --${height}`}>
      <div className='a-spinner__loading'></div>
    </div>
  );
};
